import { render, staticRenderFns } from "./HomeDetails.vue?vue&type=template&id=233d3dc0&scoped=true&"
import script from "./HomeDetails.vue?vue&type=script&lang=js&"
export * from "./HomeDetails.vue?vue&type=script&lang=js&"
import style0 from "./HomeDetails.vue?vue&type=style&index=0&id=233d3dc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d3dc0",
  null
  
)

export default component.exports